import type { SlideProps } from "@/engine/app/offsite-config";

type Phase = {
  name: string;
  label: string;
  features: string[];
};

const PHASES: Phase[] = [
  {
    name: "Phase 1",
    label: "Claude Enterprise",
    features: [
      "Sicheres KI-Werkzeug für den Alltag",
      "Datenschutz-Freigabe",
      "Firmenkontext verfügbar",
    ],
  },
  {
    name: "Phase 2",
    label: "RAG",
    features: ["KI mit unserem Wissen", "Antworten zitierbar", "Antworten prüfbar"],
  },
  {
    name: "Phase 3",
    label: "AWS-Plattform",
    features: ["Eigene Modelle", "Eigene Daten", "Eigene Kontrolle"],
  },
];

export function Slide20KIStrategie(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">KI-Strategie</div>
        <h1 className="deck-title rise rise-2">
          KI-Strategie <br />
          <span className="accent">der SVO</span>
        </h1>
      </header>

      <div className="deck-cols3">
        {PHASES.map((p, i) => (
          <div key={p.name} className={`col-card rise rise-${i + 4}`}>
            <div className="col-eyebrow">{p.name}</div>
            <h4>{p.label}</h4>
            <ul style={{ margin: "8px 0 0", padding: 0, listStyle: "none", display: "grid", gap: 6 }}>
              {p.features.map((f) => (
                <li
                  key={f}
                  style={{
                    fontSize: 14,
                    color: "rgba(255,255,255,0.85)",
                    lineHeight: 1.5,
                    paddingLeft: 18,
                    position: "relative",
                  }}
                >
                  <span
                    aria-hidden
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 8,
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      background: "var(--svo-blau)",
                    }}
                  />
                  {f}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <footer className="deck-foot" style={{ justifyContent: "flex-start", gap: 18 }}>
        <span>Datenschutz + ISMS</span>
        <span>Grünes Licht.</span>
      </footer>
    </div>
  );
}
